import React, { useRef, useState, useEffect } from "react"
import { connect } from "react-redux"

import logo from "../../images/rad/rad-spraypaint-logo.svg"
import shopLogo from "../../images/rad/rad-logo-shop.svg"

const SoftFooter = ({ mobile, shop = false }) => {
  const canvasRef = useRef(null)
  const colorWheel = [
    "#A8FF43",
    "#D4FF42",
    "#FFFD42",
    "#FFD142",
    "#FFA542",
    "#FF7942",
    "#FF4D42",
    "#FF4263",
    "#FF428F",
    "#FF42BC",
    "#FF42E8",
    "#E540EA",
    "#CC3DEC",
    "#B33AEE",
    "#9A37F1",
    "#8134F3",
    "#6731F5",
    "#4E2EF8",
    "#352BFA",
    "#1C28FC",
    "#0325FF",
    "#0965FF",
    "#0FA2FF",
    "#16DDFF",
    "#1CFFE9",
    "#22FFB5",
    "#29FF83",
    "#2FFF55",
    "#41FF36",
    "#76FF3C",
  ]
  let [canvasHeight, setCanvasHeight] = useState(null)
  let [canvasWidth, setCanvasWidth] = useState(null)
  let [canvas, setCanvas] = useState(null)
  let [ctx, setCtx] = useState(null)
  let [colorIdx, setColorIdx] = useState(0)
  let [pos, setPos] = useState({ x: null, y: null })

  useEffect(() => {
    const canvas = canvasRef.current
    const context = canvas.getContext("2d")
    setCanvas(canvas)
    setCtx(context)
    if (typeof window !== null) {
      setCanvasHeight(mobile ? 500 : 600)
      setCanvasWidth(document.body.getBoundingClientRect().width)
    }
    const colorLoop = setInterval(() => {
      _advanceColor()
    }, 150)
    return () => {
      clearInterval(colorLoop)
    }
  }, [colorIdx, mobile])

  function _onMouseMove(e) {
    _draw(e.clientX, e.clientY)
  }

  function _onTouchMove(e) {
    _draw(e.touches[0].clientX, e.touches[0].clientY)
  }

  function _advanceColor() {
    let len = colorWheel.length - 1
    colorIdx === len ? setColorIdx(0) : setColorIdx(colorIdx => colorIdx + 1)
  }

  function _draw(clientX, clientY) {
    // if (e.buttons !== 1) return

    let rect = canvas.getBoundingClientRect()
    ctx.beginPath()
    ctx.lineWidth = 100
    ctx.shadowBlur = 90
    ctx.lineJoin = ctx.lineCap = "round"
    ctx.strokeStyle = colorWheel[colorIdx]
    ctx.shadowColor = colorWheel[colorIdx + 1]
    if (pos.x !== null || pos.y !== null) {
      ctx.moveTo(pos.x - 0.1, pos.y - 0.1)
    }

    ctx.lineTo(clientX - rect.left, clientY - rect.top)
    setPos({ x: clientX - rect.left, y: clientY - rect.top })

    ctx.stroke()
  }
  return (
    <div id="softFooter">
      <img
        src={shop ? shopLogo : logo}
        alt={shop ? "RAD Shop Logo" : "RAD Logo"}
      />
      <canvas
        ref={canvasRef}
        width={canvasWidth}
        height={canvasHeight}
        onMouseMove={_onMouseMove.bind(this)}
        onTouchMove={_onTouchMove.bind(this)}
      ></canvas>
    </div>
  )
}
export default connect(
  state => ({
    mobile: state.global.mobile,
  }),
  null
)(SoftFooter)
